import { memo, useState } from "react";
import { Modal, Button, Typography, Divider } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import IntlMessages from "../Message/IntlMessages";
import { makeBrowserDownload } from "../../utils/download";
import axios from "axios";
import DangerousMessage from "components/Message/DangerousMessage";
import classNames from "classnames";
import VulnerableSoundFile from "components/VulnerableSoundFile";

const { Link } = Typography;

const RiskProfile = ({ code, close, state, actions, ...modalProps }) => {
  const {
    sellVulnerableInvestorMessage,
    sellVulnerableInvestorFile,
    sellVulnerableInvestorSoundFile,
    factsheet,
    securityDisplay,
    securityNameEn,
  } = state ?? {};
  const [isPlaying, setIsPlaying] = useState(false);

  function _onAccept() {
    close();
    setIsPlaying(false);
    actions?.onAccept && actions.onAccept(code);
  }

  function _onCancel() {
    close();
    setIsPlaying(false);
    actions?.onCancel && actions.onCancel();
  }

  function downloadFile() {
    let path = factsheet.split("/");
    path.splice(-1, 1);
    path.push(sellVulnerableInvestorFile);
    let newPath = path.join("/");
    axios({
      url: `/static${newPath}`,
      method: "GET",
      responseType: "blob",
    }).then((response) => {
      makeBrowserDownload(response.data, `${securityDisplay}_${securityNameEn}.pdf`, "application/pdf");
    });
  }

  return (
    <Modal {...modalProps} maskClosable={false} onCancel={close}>
      {modalProps.visible && (
        <div className="mnc-modal-disclaimer">
          <div className="modal-mnc-head">
            <h5 className="m-0">
              <IntlMessages id="modal.disclaimer.header.risk-profile" />
            </h5>
            <Button className="btn button-ktb-close" onClick={_onCancel}>
              <i className="feather-icon icon-x"></i>
            </Button>
          </div>
          <div
            className="modal-mnc-body"
            style={{
              whiteSpace: "pre-wrap",
            }}
          >
            {sellVulnerableInvestorSoundFile && (
              <>
                <VulnerableSoundFile
                  isPlaying={isPlaying}
                  setIsPlaying={setIsPlaying}
                  className="mb-2"
                  security={securityDisplay}
                  url={`/static${sellVulnerableInvestorSoundFile}`}
                />
                <Divider>
                  <small>
                    <IntlMessages id="global.or" />
                  </small>
                </Divider>
              </>
            )}
            {sellVulnerableInvestorMessage && (
              <DangerousMessage.Div
                className={classNames({ "mt-2": sellVulnerableInvestorSoundFile })}
                html={sellVulnerableInvestorMessage}
              />
            )}
            {sellVulnerableInvestorFile ? (
              <div className="p-3">
                <Link onClick={() => downloadFile(sellVulnerableInvestorFile)}>
                  <DownloadOutlined />
                  <IntlMessages id="modal.disclaimer.header.more-details" />
                </Link>
              </div>
            ) : null}
          </div>
          <div className="modal-mnc-footer">
            <div className="row justify-content-center">
              <div className="col-6 pe-1 pe-md-2">
                <div className="d-grid">
                  <Button data-logout-btn className="btn button-ktb-line" onClick={_onCancel}>
                    <IntlMessages id="global.cancel" />
                  </Button>
                </div>
              </div>
              <div className="col-6 ps-1 ps-md-2">
                <div className="d-grid">
                  <Button data-accept-btn className="btn button-ktb-main" onClick={_onAccept}>
                    <IntlMessages id="global.continue" />
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default memo(RiskProfile);
